import type { ILightingClassConfig, MCustomClassData } from "types";
import { MClassLavTargetValuesEnum, MClassUoTargetValuesEnum, MClassUlTargetValuesEnum, MClassFTiTargetValuesEnum, MClassReiTargetValuesEnum } from "types";
import type { ResultItem } from "../types";

export function getSelectedRoadClass(lightingClassConfig: ILightingClassConfig): string | undefined {
  return lightingClassConfig.roadClasses ?? lightingClassConfig.customClasses?.mainCustomClass?.class_type;
}

export function isPorCRoadClass(roadClass: string | undefined): boolean {
  return Boolean(roadClass && (/^[PC]\d/.test(roadClass) || /^[PC]/.test(roadClass)));
}

export function isMRoadClass(roadClass: string | undefined): boolean {
  return Boolean(roadClass && (/^M\d/.test(roadClass) || roadClass.startsWith("M")));
}

export function getRoadState(result: ResultItem, isPorC: boolean, isM: boolean): string | null {
  if (isPorC) return result?.result?.e_state?.toLowerCase() ?? null;
  if (isM) return result?.result?.l_state?.toLowerCase() ?? null;
  return null;
}

export type MRoadClassTargets = {
  targetValue: string | number;
  uo_target: string | number;
  ul_target: string | number;
  fti_target: string | number;
  rei_target: string | number;
};

export function getMRoadClassTargets(lightingClassConfig: ILightingClassConfig): MRoadClassTargets {
  const roadClass = lightingClassConfig.roadClasses as keyof typeof MClassLavTargetValuesEnum;
  const custom = lightingClassConfig.customClasses?.mainCustomClass as MCustomClassData | undefined;

  return {
    targetValue: custom?.class_type ? custom.Lm_av : MClassLavTargetValuesEnum[roadClass],
    uo_target: custom?.class_type ? custom.L_uo : MClassUoTargetValuesEnum[roadClass],
    ul_target: custom?.class_type ? custom.L_ul : MClassUlTargetValuesEnum[roadClass],
    fti_target: custom?.class_type ? custom.fTI : MClassFTiTargetValuesEnum[roadClass],
    rei_target: custom?.class_type ? custom.Rei : MClassReiTargetValuesEnum[roadClass],
  };
}
